(function () {
    "use strict";

    // Standardized DOM Element Builder Utility
    function el(tag, props = {}, children = []) {
        const element = document.createElement(tag);
        Object.entries(props).forEach(([key, val]) => {
            if (key === "className") element.className = val;
            else if (key.startsWith("on") && typeof val === "function") {
                element.addEventListener(key.slice(2).toLowerCase(), val);
            } else if (val !== null && val !== undefined) {
                element.setAttribute(key, val);
            }
        });
        children.forEach(child => {
            if (child) {
                element.appendChild(typeof child === "string" ? document.createTextNode(child) : child);
            }
        });
        return element;
    }

    // URL Query Parameter Helpers
    const getParam = (param) => new URLSearchParams(window.location.search).get(param);

    class NewsLoaderInstance {
        constructor(container) {
            this.loader = container;
            this.id = container.dataset.newsroot;
            this.skip = 0;
            this.maxItems = 10;
            this.tag = getParam("tag");

            this.init();
        }

        init() {
            const newsFilter = this.loader.querySelector(".newsfilter");
            if (!newsFilter) return;

            this.loadArticles(data => this.setUpFilter(data));

            const loadBtn = this.loader.querySelector("button.load");
            loadBtn?.addEventListener("click", () => this.loadArticles());
        }

        getBackButton(newsFilter) {
            return el("button", {
                onClick: () => {
                    newsFilter.querySelectorAll("button").forEach(b => b.setAttribute("disabled", "disabled"));
                    this.tag = null;
                    this.skip = 0;

                    const mrCheckbox = this.loader.querySelector("#mediaRelease");
                    if (mrCheckbox) mrCheckbox.checked = false;

                    const newsContent = this.loader.querySelector(".newscontent");
                    if (newsContent) newsContent.replaceChildren();

                    this.loadArticles(data => this.setUpFilter(data));
                }
            }, ["Back to all news items"]);
        }

        addBackButtonHeader(newsContent, newsFilter) {
            if (newsContent.querySelector(".newsheader")) return;

            const header = el("div", { className: "newsheader" }, [
                el("div", { className: "row" }, [
                    el("div", { className: "col-md-12" }, [
                        el("div", { className: "back" }, [this.getBackButton(newsFilter)])
                    ])
                ])
            ]);
            newsContent.insertBefore(header, newsContent.firstChild);
        }

        setUpFilter(data) {
            const newsFilter = this.loader.querySelector(".newsfilter");
            if (!newsFilter) return;

            const tagsLabel = newsFilter.dataset.tagslabel || "Tags";
            const recentLabel = newsFilter.dataset.recentlabel || "Recent";
            const mediaReleaseLabel = newsFilter.dataset.mediareleaselabel || "Media Releases";
            const newsContent = this.loader.querySelector(".newscontent");

            // 1. Build Media Release Switch Container
            let mediaReleaseContainer = newsFilter.querySelector(".media-release");
            if (!mediaReleaseContainer) {
                const mrCheck = el("input", {
                    className: "form-check-input",
                    type: "checkbox",
                    id: "mediaRelease",
                    onClick: () => {
                        this.skip = 0;
                        newsContent?.replaceChildren();
                        this.loadArticles(d => this.setUpFilter(d));
                    }
                });

                const mrLabel = el("div", {
                    className: "form-check-label",
                    for: "mediaRelease",
                    onClick: () => mrCheck.click()
                });
                mrLabel.innerHTML = mediaReleaseLabel;

                mediaReleaseContainer = el("div", { className: "media-release form-check form-switch" }, [
                    mrCheck,
                    mrLabel
                ]);
            }

            // 2. Build Tags UI Container
            let filterBackButton;
            let tagsContainer = newsFilter.querySelector(".tags");

            if (!tagsContainer) {
                filterBackButton = this.getBackButton(newsFilter);
                filterBackButton.style.display = "none";

                const mobileBackContainer = el("div", { className: "back mobile" }, [filterBackButton]);
                tagsContainer = el("div", { className: "tags buttons" });

                const tagsetDiv = el("div", { className: "tagset" }, [
                    el("div", { className: "title" }, [tagsLabel]),
                    tagsContainer,
                    mediaReleaseContainer,
                    mobileBackContainer
                ]);

                newsFilter.appendChild(tagsetDiv);
            } else {
                filterBackButton = newsFilter.querySelector(".back button");
                if (filterBackButton) {
                    filterBackButton.removeAttribute("disabled");
                    filterBackButton.style.display = "none";
                }
            }

            mediaReleaseContainer.style.display = data.MediaReleases ? "" : "none";

            // Reset existing tag buttons state
            tagsContainer.querySelectorAll("button").forEach(btn => {
                btn.removeAttribute("disabled");
                btn.classList.replace("active", "inactive");
            });

            let backButtonAdded = false;

            // 3. Process Tags
            (data.Tags || []).forEach(currentTag => {
                if (currentTag.Active && currentTag.Included) {
                    let button = tagsContainer.querySelector(`button[data-tag="${currentTag.Value}"]`);

                    if (!button) {
                        button = el("button", { "data-tag": currentTag.Value }, [currentTag.Value]);
                        tagsContainer.appendChild(button);
                    }

                    if (this.tag === currentTag.Value) {
                        if (window.innerWidth < 768) {
                            newsContent?.scrollIntoView();
                        }
                        filterBackButton.style.display = "";
                        button.classList.remove("inactive");
                        button.classList.add("active");
                        this.addBackButtonHeader(newsContent, newsFilter);
                        backButtonAdded = true;
                    }

                    // Update click listener cleanly
                    button.onclick = () => {
                        this.tag = button.classList.contains("active") ? null : currentTag.Value;
                        newsFilter.querySelectorAll("button").forEach(b => b.setAttribute("disabled", "disabled"));
                        this.skip = 0;
                        newsContent?.replaceChildren();
                        this.loadArticles(d => this.setUpFilter(d));
                    };
                }
            });

            const mrChecked = mediaReleaseContainer.querySelector("input[type='checkbox']")?.checked;

            if (mrChecked) {
                if (!backButtonAdded) {
                    this.addBackButtonHeader(newsContent, newsFilter);
                }
                if (filterBackButton.style.display === "none") {
                    filterBackButton.style.display = "";
                    if (window.innerWidth < 768) {
                        newsContent?.scrollIntoView();
                    }
                }
            }

            // Toggle Tag Visibility based on Media Releases
            (data.Tags || []).forEach(t => {
                const btn = tagsContainer.querySelector(`button[data-tag="${t.Value}"]`);
                if (btn) {
                    btn.style.display = mrChecked && !t.MediaReleases ? "none" : "inline-block";
                }
            });

            // 4. Build Recent Items Container
            let recentContainer = newsFilter.querySelector(".recent");
            if (!recentContainer) {
                recentContainer = el("div", { className: "recent" });
                const recentTitleDiv = el("div", { className: "title recenttitle" });
                recentTitleDiv.innerHTML = recentLabel;

                newsFilter.appendChild(recentTitleDiv);
                newsFilter.appendChild(recentContainer);

                this.loadLatest(items => {
                    items.forEach(item => {
                        const recentLink = el("a", { href: item.Url });
                        recentLink.innerHTML = item.Name;
                        recentContainer.appendChild(el("div", { className: "item" }, [recentLink]));
                    });
                });
            }
        }

        async loadLatest(callback) {
            try {
                const res = await fetch(`/umbraco/surface/NewsSurface/GetLatest/${this.id}`, { cache: "no-store" });
                if (!res.ok) throw new Error("Failed to load latest news");
                const data = await res.json();
                if (typeof callback === "function") callback(data);
            } catch (err) {
                console.error("Error loading recent news:", err);
            }
        }

        async loadArticles(callback) {
            const mediaReleaseCheckbox = this.loader.querySelector("#mediaRelease");
            const mediaRelease = mediaReleaseCheckbox ? mediaReleaseCheckbox.checked : false;

            const params = new URLSearchParams({
                skip: this.skip,
                take: this.maxItems,
                ...(this.tag && { tag: this.tag }),
                ...(mediaRelease && { mediaRelease: true })
            });

            try {
                const res = await fetch(`/umbraco/surface/NewsSurface/LoadMore/${this.id}?${params.toString()}`, { cache: "no-store" });
                if (!res.ok) throw new Error("Failed to fetch articles");
                const data = await res.json();

                const newsContent = this.loader.querySelector(".newscontent");

                // Process and fetch HTML cards in parallel
                if (Array.isArray(data.Urls) && newsContent) {
                    const htmlPromises = data.Urls.map(async articleUrl => {
                        const fullUrl = `${articleUrl}?${this.tag ? `&tag=${encodeURIComponent(this.tag)}` : ""}`;
                        const response = await fetch(fullUrl);
                        return response.text();
                    });

                    const htmlContents = await Promise.all(htmlPromises);
                    htmlContents.forEach(html => {
                        const container = el("div");
                        container.innerHTML = html;
                        newsContent.appendChild(container);
                    });
                }

                this.skip += this.maxItems;
                const loadBtn = this.loader.querySelector("button.load");
                if (loadBtn) {
                    loadBtn.style.display = this.skip >= (data.TotalItems || 0) ? "none" : "";
                }

                if (typeof callback === "function") callback(data);
            } catch (err) {
                console.error("Error loading articles:", err);
            }
        }
    }

    // Initialize all news loader instances on page load
    document.addEventListener("DOMContentLoaded", () => {
        document.querySelectorAll(".newsload").forEach(container => new NewsLoaderInstance(container));
    });
})();